import axios from "axios";
import { getBaseUrl } from "../../service/apiUrl";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const STATUSES = Object.freeze({
  IDLE: "idle",
  ERROR: "error",
  LOADING: "loading",
});

const getSponsorSlice = createSlice({
  name: "sponsor",
  initialState: {
    data: [],
    status: STATUSES.IDLE,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSponsor.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(fetchSponsor.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(fetchSponsor.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
      });
  },
});

export const { setSponsor, setStatus } = getSponsorSlice.actions;
export default getSponsorSlice.reducer;
export const fetchSponsor = createAsyncThunk("sponsor/fetch", async () => {
  const res = await axios.get(
    `${getBaseUrl()}/Sponsorget`,
  );
  const data = res.data;
  return data.data;
});
